module.exports = __webpack_public_path__ + "static/media/Artboard7.dd0907d4.png";